module.exports = __webpack_public_path__ + "static/media/dashboard.1ac81d3c.jpg";